var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eapps-main-dashboard" },
    [
      _c(
        "PanelRow",
        [
          _c(
            "Panel",
            { staticClass: "logins two-thirds" },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c("h2", [
                    _vm._v(_vm._s(_vm._f("trans")("dashboard.logins.title")))
                  ]),
                  _vm._v(" "),
                  _c("ButtonSwitch", {
                    staticClass: "logins-view",
                    attrs: { options: _vm.viewOptions },
                    model: {
                      value: _vm.loginsView,
                      callback: function($$v) {
                        _vm.loginsView = $$v
                      },
                      expression: "loginsView"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chart-holder" },
                [
                  _c("LineChart", {
                    attrs: {
                      data: _vm.logins.slice().reverse(),
                      axis: _vm.axis.slice().reverse(),
                      opts: _vm.chartOpts.chart,
                      setopts: _vm.chartOpts.set
                    }
                  })
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "Panel",
            { staticClass: "third-keep numberstats" },
            [
              _vm.newLogins
                ? [
                    _c("h2", [
                      _vm._v(_vm._s(_vm._f("trans")("users:daily_logins")))
                    ]),
                    _vm._v(" "),
                    _c("Trend", { attrs: { data: _vm.newLogins } })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.newUsers
                ? [
                    _c("h2", [
                      _vm._v(_vm._s(_vm._f("trans")("users:daily_new")))
                    ]),
                    _vm._v(" "),
                    _c("Trend", { attrs: { data: _vm.newUsers } })
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "Panel",
            { staticClass: "third" },
            [
              _c("h2", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v(_vm._s(_vm._f("trans")("billings:title")))
              ]),
              _vm._v(" "),
              _c("Unpaid"),
              _vm._v(" "),
              _vm.billingPlan
                ? _c("Information", {
                    attrs: { item: _vm.billingPlan, fields: _vm.billingFields }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("CreditsUsage", { attrs: { billing: _vm.current_billing } })
            ],
            1
          ),
          _vm._v(" "),
          _c("Panel", { staticClass: "two-thirds" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18c1bd05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18c1bd05","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/general/Dashboard.vue
// module id = null
// module chunks = 